/* @flow weak */
import CurrentUser from 'auth/CurrentUser';

// NOTE: This function will likely go away after awhile since we should pass Membership or User
// objects to components that render names. I am just keeping it around for now since it's a
// quick way to output names in a chat conversation.
export default function getParticipantNames(chat) {
  const currentUserId = CurrentUser.getUser().id;
  return chat.getMemberships().filter(membership => {
    return membership.getMember().id !== currentUserId;
  }).map(membership => {
    return membership.getMember().getName();
  });
}



// WEBPACK FOOTER //
// ./src/chat/utils/getParticipantNames.js